var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"lg":"12"}},[_c('v-card',{staticClass:"card--shadow"},[_c('presumptive-list',{attrs:{"township_id":_vm.$route.params.township_id,"presumptiveData":_vm.presumptiveData}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }